const $ = require("jquery");
import "notifyjs-browser";

export const Notify = {
    /**
     * Build custom styles.
     *
     * @param $template
     */
    init: function ($template) {
        $.notify.addStyle('virta', {
            html: $template.html(),
            classes: {
                default: {},
                success: {},
                error: {}
            }
        });
    },

    /**
     * Display a default notification.
     *
     * @param message
     */
    default: function (message) {
        this.notification(message, 'default');
    },

    /**
     * Display a success notification.
     *
     * @param message
     */
    success: function (message) {
        this.notification(message, 'success');
    },

    /**
     * Display an error notification.
     *
     * @param message
     */
    error: function (message) {
        this.notification(message, 'error');
    },

    /**
     * Display a notification.
     *
     * @param message
     * @param type
     */
    notification: function (message, type) {
        if (typeof type === 'undefined') {
            type = 'default';
        }

        let $icon;
        switch (type) {
            case 'default':
                $icon = $('<i />').addClass('large inverted info circle icon');
                break;
            case 'success':
                $icon = $('<i />').addClass('large inverted check circle icon');
                break;
            case 'error':
                $icon = $('<i />').addClass('large inverted warning sign icon');
                break;
        }

        $.notify({
            message: message,
            image: $icon.wrap('<p>').parent().html()
        }, {
            globalPosition: 'bottom right',
            style: 'virta',
            className: type,
            showAnimation: 'fadeIn',
            hideAnimation: 'fadeOut'
        });
    }
};

export default Notify;